import { SET_COPIED_SHIPMENT, SET_COPIED_SHIPMENT_STATUS, CLEAR_COPIED_SHIPMENT } from '#action/types';

export const setCopiedShipment = shipment => dispatch => {
  dispatch({ type: SET_COPIED_SHIPMENT, payload: shipment });
};

export const setCopiedShipmentStatus = status => dispatch => {
  dispatch({ type: SET_COPIED_SHIPMENT_STATUS, payload: status });
};

export const clearCopiedShipment = () => dispatch => dispatch({ type: CLEAR_COPIED_SHIPMENT });
